module.exports = __webpack_public_path__ + "static/img/A61.ee4eeef3.jpg";